import type { ComponentProps } from 'react';

import { KeyRound } from 'lucide-react';

import { DataActionReader } from '@/components/ui/dataActionReader/dataActionReader';
import type { DataEditorData } from '@/components/ui/dataEditor/dataEditor.type';
import type { DataImporterData } from '@/components/ui/dataImporter/dataImporter.type';
import { FormBody } from './formBody/formBody';
import type { SegmentDetail } from './segmentDetail';

export const SegmentBody = ({
  link,
  linkCreatedByAccount,
  workflowContext
}: Omit<ComponentProps<typeof SegmentDetail>, 'traceId'>) => {
  const { data, action } = link;

  // If data is of type string, it means it contains encrypted data.
  if (typeof data === 'string') {
    return (
      <div className="mb-3 flex">
        <dl className="grow-0 rounded-md border border-border bg-accent px-2 py-1">
          <dt className="mb-1 flex items-center font-bold text-[11px] tracking-wide">
            ACTION ENCRYPTED <KeyRound className="ml-2 shrink-0" size={22} />
          </dt>
        </dl>
      </div>
    );
  }

  const isDataTool = action && (action.dataImporter || action.dataEditor);

  if (isDataTool) {
    return (
      <DataActionReader
        action={action}
        data={data as DataEditorData | DataImporterData}
      />
    );
  }

  return (
    <FormBody
      link={link}
      linkCreatedByAccount={linkCreatedByAccount}
      workflowContext={workflowContext}
    />
  );
};
